import React from 'react';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';
import ComboBox from '../../../components/ComboBox/ComboBox';
import Slider from '../../../components/Slider/Slider';

function getDefaultVoiceSample(ln, name) {
    const phrases = {
        en: (name) => `Hi, my name is ${name}. How are you?`,
        es: (name) => `Hola, mi nombre es ${name}. ¿Cómo estás?`,
        fr: (name) => `Salut, je m'appelle ${name}. Comment ça va?`,
        de: (name) => `Hallo, ich heiße ${name}. Wie geht es dir?`,
        ru: (name) => `Привет, меня зовут ${name}. Как ваши дела?`,
        it: (name) => `Ciao, mi chiamo ${name}. Come stai?`,
        pt: (name) => `Olá, meu nome é ${name}. Como você está?`,
        tr: (name) => `Merhaba, benim adım ${name}. Nasılsın?`,
        ar: (name) => `مرحبًا ، اسمي ${name}. كيف حالك؟`,
    };
    if (phrases[ln]) {
        return phrases[ln](name);
    }
    return `Hi, my name is ${name}. We couldn't found a voice sample for the language you have selected. You may contact us via Ask Suport menu and request to add it`;
}

class AlanButtonVoiceSelector extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { langId, regId, id, voices, voiceInfo } = this.props;
        const speedOption = this.getCurrentSpeedVoiceOption(voices, voiceInfo, langId, regId, id);
        const pitchOption = this.getCurrentPitchVoiceOption(voices, voiceInfo, langId, regId, id);

        this.state = {
            langId,
            regId,
            id,
            speedOption,
            pitchOption
        };

        this.audio = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const { langId, regId, id, voices, voiceInfo } = this.props;
        const speedOption = this.getCurrentSpeedVoiceOption(voices, voiceInfo, langId, regId, id);
        const pitchOption = this.getCurrentPitchVoiceOption(voices, voiceInfo, langId, regId, id);

        if (JSON.stringify(prevProps.voices) !== JSON.stringify(voices)) {
            this.setState({
                langId,
                regId,
                id,
                speedOption,
                pitchOption
            });
        } else if (langId !== prevProps.langId || regId !== prevProps.regId || id !== prevProps.id) {
            if (prevProps.langId && prevProps.regId && prevProps.id) {
                this.setState({
                    langId,
                    regId,
                    id,
                    speedOption: this.getCurrentSpeedVoiceOption(prevProps.voices, prevProps.voiceInfo, prevProps.langId, prevProps.regId, prevProps.id),
                    pitchOption: this.getCurrentPitchVoiceOption(prevProps.voices, prevProps.voiceInfo, prevProps.langId, prevProps.regId, prevProps.id)
                });
            }
        }
    }

    componentWillUnmount() {
        ReactTooltip.hide();
    }

    getCurrentPitchVoiceOption = (voices, voiceInfo, langId, regId, id) => {
        const voiceOptions = voiceInfo.options;
        let pitchOption, names;
        let savedVoiceOption = {};
        if (voiceOptions) {
            savedVoiceOption = voiceOptions.find(option => option.name === 'pitch');
        }

        if (voices[langId]) {
            if (voices[langId][regId]) {
                names = voices[langId][regId].sort();
                const selectedName = names.find(name => name.id === id);
                if (selectedName && selectedName.options) {
                    pitchOption = selectedName.options.find(option => option.name === 'pitch');
                }
            }
        }
        return {
            ...pitchOption,
            ...savedVoiceOption
        };
    }

    getCurrentSpeedVoiceOption = (voices, voiceInfo, langId, regId, id) => {
        const voiceOptions = voiceInfo.options;
        let speedOption, names;
        let savedVoiceOption = {};
        if (voiceOptions) {
            savedVoiceOption = voiceOptions.find(option => option.name === 'speed');
        }

        if (voices[langId]) {
            if (voices[langId][regId]) {
                names = voices[langId][regId].sort();
                const selectedName = names.find(name => name.id === id);
                if (selectedName && selectedName.options) {
                    speedOption = selectedName.options.find(option => option.name === 'speed');
                }
            }
        }
        return {
            ...speedOption,
            ...savedVoiceOption
        };
    }

    selectLanguage = (langId) => {
        const { voices } = this.props;
        if (!voices[langId]) return;
        const defaultRegion = Object.keys(voices[langId])[0];
        const selectedNameInfo = voices[langId][defaultRegion][0];

        this.setState({
            langId,
            regId: defaultRegion,
            id: selectedNameInfo.id,
        }, () => {
            this.changeVoice();
        });
    }

    selectRegion = (regId) => {
        const { voices } = this.props;
        const { langId } = this.state;
        const selectedNameInfo = voices[langId][regId][0];

        this.setState({
            regId,
            id: selectedNameInfo.id,
        }, () => {
            this.changeVoice();
        });
    }

    selectName = ({ id }) => {
        this.setState({
            id: id,
        }, () => {
            this.changeVoice();
        });
    }

    play = async () => {
        const { voices, voiceInfo } = this.props;
        const { langId, regId, id } = this.state;

        const names = voices[langId][regId];
        const nameInfo = _.find(names, { id: id });
        const speedOption = this.getCurrentSpeedVoiceOption(voices, voiceInfo, langId, regId, id);
        const pitchOption = this.getCurrentPitchVoiceOption(voices, voiceInfo, langId, regId, id);
        const voice = voiceInfo.voiceData;

        for (let i = 0; i < voice[langId][regId][0].options.length; i++) {
            if (voice[langId][regId][0].options[i].name === 'speed') {
                voice[langId][regId][0].options[i] = { ...voice[langId][regId][0].options[i], val: speedOption.val || voice[langId][regId][0].options[i].def };
                break;
            }
        }

        for (let i = 0; i < voice[langId][regId][0].options.length; i++) {
            if (voice[langId][regId][0].options[i].name === 'pitch') {
                voice[langId][regId][0].options[i] = { ...voice[langId][regId][0].options[i], val: pitchOption.val || voice[langId][regId][0].options[i].def };
                break;
            }
        }

        const link = await this.props.getTextToSpeach({
            text: nameInfo.voiceSample?.replace(/\$\{name\}/i, nameInfo.name) || getDefaultVoiceSample(langId, nameInfo.name),
            voice: JSON.stringify(voice)
        });

        if (link) {
            this.audio.current.pause();
            this.audio.current.src = link;
            this.audio.current.playbackRate = speedOption.val || speedOption.def;
            var playPromise = this.audio.current.play();

            if (playPromise !== undefined) {
                playPromise.then(_ => {
                }).catch(error => {
                });
            }
        }
    }

    changeVoice() {
        const { langId, regId, id, speedOption, pitchOption } = this.state;
        this.props.changeVoice(this.props.langId, langId, regId, id, speedOption.val || speedOption.def, pitchOption.val || pitchOption.def);
    }

    removeVoice = () => {
        const { langId, removeVoice } = this.props;
        if (langId) {
            removeVoice(langId);
        }
    }

    onVoiceSpeedAfterChange = _.debounce((newSpeachSpeed) => {
        const { langId, regId, id, speedOption, pitchOption } = this.state;
        this.setState({ speedOption: { ...speedOption, val: newSpeachSpeed } });
        this.props.changeVoice(this.props.langId, langId, regId, id, newSpeachSpeed, pitchOption.val || pitchOption.def);
    }, 800)

    onVoiceSpeedChange = (newSpeachSpeed) => {
        this.audio.current.playbackRate = newSpeachSpeed;
    }

    onVoicePitchAfterChange = _.debounce((newSpeachPitch) => {
        const { langId, regId, id, speedOption, pitchOption } = this.state;
        this.setState({ pitchOption: { ...pitchOption, val: newSpeachPitch } });
        this.props.changeVoice(this.props.langId, langId, regId, id, speedOption.val || speedOption.def, newSpeachPitch);
    }, 800)

    onVoicePitchChange = (newSpeachPitch) => {
    }

    renderThumb = (props, state) => {
        return <div {...props}>
            <div className="alan-button-voices-form_speed-value">
                {state.valueNow}
            </div>
        </div>;
    };

    render() {
        const {
            voices,
            showRemoveBtn,
        } = this.props;

        const {
            langId,
            regId,
            id,
            speedOption,
            pitchOption,
        } = this.state;

        const languages = [
            'en',
            ...Object.keys(voices)
                .filter((el) => el !== 'en')
                .sort(),
        ];

        let regions, names;

        if (voices[langId]) {
            regions = Object.keys(voices[langId]).sort();
            if (voices[langId][regId]) {
                names = voices[langId][regId].sort();
            }
        }

        return <div className="alan-button-voice-selector">
            <div className="alan-button-voices-form_row">
                {(languages && languages.length > 0 && voices[langId]) &&
                    <div className="alan-button-voices-form_col">
                        <ComboBox
                            values={languages}
                            width="82px"
                            listMaxHeight="150px"
                            selectedValueId={langId}
                            onValueSelect={this.selectLanguage}
                            renderItem={(langItem) => {
                                return <div className="voice-settings-item">{langItem}</div>;
                            }} />
                    </div>}
                {regions && regions.length > 0 &&
                    <div className="alan-button-voices-form_col">
                        <ComboBox
                            values={regions}
                            width="82px"
                            listMaxHeight="150px"
                            selectedValueId={regId}
                            onValueSelect={this.selectRegion}
                            renderItem={(regItem) => {
                                return <div className="voice-settings-item">{regItem}</div>;
                            }} />
                    </div>}
                {names && names.length &&
                    <div className="alan-button-voices-form_col">
                        <ComboBox
                            values={names}
                            valueKey="id"
                            valueName="name"
                            width="142px"
                            listMaxHeight="150px"
                            selectedValueId={id}
                            onValueSelect={this.selectName}
                            renderItem={(nameItem) => {
                                return <div className="voice-settings-item">{nameItem.name}</div>;
                            }} />
                    </div>}

                <div>
                    {speedOption && speedOption.max && <div className="alan-button-voices-form_col">
                        <div className="alan-button-voices-form_rate-control">
                            <Slider
                                min={speedOption.min}
                                max={speedOption.max}
                                value={speedOption.val || speedOption.def}
                                key={`${langId}-${regId}-${id}`}
                                step={0.1}
                                width={370}
                                fillTrack={true}
                                onAfterChange={this.onVoiceSpeedAfterChange}
                                onChange={this.onVoiceSpeedChange}
                                renderThumb={this.renderThumb}
                            />
                            <div className="alan-button-voices-form_rate-control-header">Speed</div>
                        </div>
                    </div>}

                    {pitchOption && pitchOption.max && <div className="alan-button-voices-form_col">
                        <div className="alan-button-voices-form_rate-control">
                            <Slider
                                min={pitchOption.min}
                                max={pitchOption.max}
                                value={pitchOption.val || pitchOption.def}
                                key={`${langId}-${regId}-${id}`}
                                step={0.1}
                                width={370}
                                fillTrack={true}
                                onAfterChange={this.onVoicePitchAfterChange}
                                onChange={this.onVoicePitchChange}
                                renderThumb={this.renderThumb}
                            />
                            <div className="alan-button-voices-form_rate-control-header">Pitch</div>
                        </div>
                    </div>}
                </div>



                <div className="alan-button-voices-form_col">
                    <div
                        className="action-btn light-blue-with-border alan-button-voices-form_play-voice-btn"
                        onClick={this.play}
                        data-tip="Preview voice"
                        data-for="previewVoice"
                        data-place="top"
                        data-effect="solid"
                        data-class="tutor-dark-tooltip nowrap" >
                        <i className="icon icon-alan-triangle-right" />
                        <ReactTooltip id="previewVoice" />
                    </div>
                </div>

                {showRemoveBtn &&
                    <div className="alan-button-voices-form_col">
                        <div
                            className="action-btn light-blue-with-border alan-button-voices-form_remove-voice-btn"
                            onClick={this.removeVoice}
                            data-tip="Remove voice"
                            data-for="removewVoice"
                            data-place="top"
                            data-effect="solid"
                            data-class="tutor-dark-tooltip nowrap" >
                            <i className="icon icon-alan-trash" />
                            <ReactTooltip id="removewVoice" />
                        </div>
                    </div>
                }
            </div>
            <audio className="hidden" ref={this.audio}></audio>
        </div>;
    }
}

export default AlanButtonVoiceSelector;